import { createReducer, on } from '@ngrx/store';
import { UserProfileState, initialUserProfileState } from './user-profile.state';
import {
  clearUserProfile,
  changePasswordFailure,
  changePasswordRequested,
  changePasswordSuccess,
  clearChangePasswordStatus,
  loadUserProfile,
  loadUserProfileFailure,
  loadUserProfileSuccess,
  updateUserProfileWithRole
} from './user-profile.actions';

export const userProfileReducer = createReducer(
  initialUserProfileState,

  on(loadUserProfile, (state): UserProfileState => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(loadUserProfileSuccess, (state, { profile }): UserProfileState => ({
    ...state,
    profile,
    isLoading: false,
    error: null,
  })),

  on(loadUserProfileFailure, (state, { error }): UserProfileState => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(changePasswordRequested, (state): UserProfileState => ({
    ...state,
    isChangingPassword: true,
    changePasswordError: null,
    changePasswordSucceeded: false,
  })),

  on(changePasswordSuccess, (state): UserProfileState => ({
    ...state,
    isChangingPassword: false,
    changePasswordError: null,
    changePasswordSucceeded: true,
  })),

  on(changePasswordFailure, (state, { error }): UserProfileState => ({
    ...state,
    isChangingPassword: false,
    changePasswordError: error,
    changePasswordSucceeded: false,
  })),

  on(clearChangePasswordStatus, (state): UserProfileState => ({
    ...state,
    isChangingPassword: false,
    changePasswordError: null,
    changePasswordSucceeded: false,
  })),

  on(clearUserProfile, (): UserProfileState => ({ ...initialUserProfileState })),

  on(updateUserProfileWithRole, (state,
    { roleUserId, roleId, roleName, role, firstName, lastName }): UserProfileState => ({
    ...state,
    profile: state.profile ? {
      ...state.profile,
      roleUserId,
      roleId,
      roleName,
      role,
      firstName: firstName !== undefined && firstName.trim().length > 0
        ? firstName
        : state.profile.firstName,
      lastName: lastName !== undefined && lastName.trim().length > 0
        ? lastName
        : state.profile.lastName,
    } : null,
  }))
);
